/**
 * constants.ts — ค่าคงที่ของโดเมน
 */
/** สถานะใบเสนอราคา */
export const QUOTATION_STATUSES = ['draft', 'sent', 'accepted', 'rejected'];
export const QUOTATION_STATUS_LABELS = {
    draft: 'แบบร่าง',
    sent: 'ส่งแล้ว',
    accepted: 'อนุมัติ',
    rejected: 'ปฏิเสธ',
};
/** สถานะใบกำกับภาษี / ใบเสร็จรับเงิน */
export const TAX_INVOICE_STATUSES = ['issued', 'paid', 'cancelled'];
export const TAX_INVOICE_STATUS_LABELS = {
    issued: 'ออกแล้ว',
    paid: 'ชำระแล้ว',
    cancelled: 'ยกเลิก',
};
/** บทบาทผู้ใช้ */
export const USER_ROLES = ['admin', 'user'];
export const USER_ROLE_LABELS = {
    admin: 'ผู้ดูแลระบบ',
    user: 'ผู้ใช้งาน',
};
/** ประเภทเอกสารต้นทางที่อ้างอิงได้ */
export const SOURCE_TYPES = ['quotation'];
/**
 * จำนวนรายการที่พออยู่ในหน้า A4 หนึ่งหน้าโดยประมาณ
 *
 * ใช้เป็นคำแนะนำใน UI เท่านั้น (เตือนผู้ใช้ว่าเอกสารจะยาวเกินหนึ่งหน้า)
 * ไม่ใช่ข้อจำกัดจริง — เอกสาร PDF ปล่อยให้เบราว์เซอร์ตัดหน้าตามเนื้อหา
 * จึงใส่รายการได้ไม่จำกัดโดยไม่มีข้อมูลตกหล่น ต่างจากระบบเดิมที่จำกัด 15 รายการต่อใบ
 */
export const ITEMS_PER_PAGE = 15;
/** จำนวนวันเริ่มต้นที่ใบเสนอราคามีผล นับจากวันที่เอกสาร */
export const DEFAULT_QUOTATION_VALID_DAYS = 15;
/** ค่าเริ่มต้นของหน่วยนับสินค้า */
export const DEFAULT_UNIT = 'ชิ้น';
/** เขตเวลาที่ใช้ตัดรอบรายงาน — ธุรกิจอยู่ไทยทั้งหมด */
export const BUSINESS_TIMEZONE = 'Asia/Bangkok';
//# sourceMappingURL=constants.js.map